export default __webpack_public_path__ + "static/HealthHistory-73e6c21d6fa494984c174f2a8ff46251.pdf";